export const colorsData = [
    {
      name: "Red",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/lm92enskxriy9abwqefi",
    },
    {
      name: "Blue",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/dbm6wrbcgjaw2cxxqcow",
    },
    {
      name: "Green",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/hiplpl9tnfte4a9ekbqh",
    },
    {
      name: "Yellow",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/rltr1llzen3g7e4dozdx",
    },
    {
      name: "Black",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/qdl6rnztygtoslry0jip",
    },
    {
      name: "White",
      imageUrl: "https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/v1/Colors/zt8cianeeu4qsdyso1ck",
    },
  ];